import { render, staticRenderFns } from "./SurveyImageHeader.vue?vue&type=template&id=ad39b9d0&"
import script from "./SurveyImageHeader.vue?vue&type=script&lang=ts&"
export * from "./SurveyImageHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports